import { render, staticRenderFns } from "./MarketingDataModal.vue?vue&type=template&id=eb04119a&scoped=true"
import script from "./MarketingDataModal.vue?vue&type=script&lang=js"
export * from "./MarketingDataModal.vue?vue&type=script&lang=js"
import style0 from "./MarketingDataModal.vue?vue&type=style&index=0&id=eb04119a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb04119a",
  null
  
)

export default component.exports